module.exports = __webpack_public_path__ + "videos/BOLD_SUMMER_LOOP.4867c1c.mp4";